<template>
  <div></div>
</template>

<script>
export default {
  name: "address",
  created() {
    document.title = '地址管理 - JapanHui';
  },
}
</script>

<style scoped>

</style>